module.exports = "<!-- LOAD -->\r\n<div id=\"preloader\"></div>"